import { matchTimeUnitKey, useLocalizeText } from '@mews/framework';
import { isDayUse } from '@mews-commander/utils';
import { useService } from '@mews-commander/legacy-entities/src/utils/useService';
import { isBookableService } from '@mews-commander/legacy-entities/src/ducks/servicesNew';

interface Options {
    form?: 'singular' | 'plural';
    perTimeUnit?: boolean;
}

export const useLocalizedTimeUnit = (serviceId: string, { form = 'singular' }: Options = {}) => {
    const service = useService(serviceId);
    const localizeText = useLocalizeText();

    if (!service || !isBookableService(service)) {
        return null;
    }

    const timeUnit = service.data.value?.timeUnit;
    const endOffset = service.data.value?.endOffset;

    if (!timeUnit || !endOffset) return null;

    const textKey = matchTimeUnitKey({
        timeUnit,
        isServiceDayUse: isDayUse(service),
        plural: form === 'plural',
    });

    if (!textKey) {
        return null;
    }

    return localizeText({ textKey });
};
